import { inject, Injectable } from "@angular/core";
import { ConfigService } from "../config/config.service";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { ApiRequestOptions } from "./models/api-request-options.model";

@Injectable({
  providedIn: 'root',
})
export class ApiRequestService {
  private readonly _configService: ConfigService = inject(ConfigService)

  constructor(private http: HttpClient) {}

  public get$<T>(
    route: string,
    options?: ApiRequestOptions
  ): Observable<T> {
    return this.http.get<T>(`${this._configService.config.masterlookupservice.url}${route}`)
  }

  public put$<T, U>(
    route: string,
    dataObject: U,
    options?: ApiRequestOptions
  ): Observable<T> {
    return this.http.put<T>(
      `${this._configService.config.masterlookupservice.url}${route}`,
      dataObject,
      options
    );
  }

  public post$<T, U>(
    route: string,
    dataObject: U,
    options?: ApiRequestOptions
  ): Observable<T> {
    return this.http.post<T>(
      `${this._configService.config.masterlookupservice.url}${route}`,
      dataObject,
      options
    );
  }
}
